// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Star Trek Universe - Warp Gates Configuration
 */

export const warpGates = [
  {
    id: 'gate-startrek-masseffect',
    name: 'Subspace Anomaly Beta',
    type: 'warpgate',
    distance: 20,
    destinationUniverse: 'masseffect',
    fromUniverse: 'startrek',
    fromSystem: 1900,
    toSystem: 900,
    destinationGate: 'gate-masseffect-startrek',
    energyCost: 50,
    threat: 'MODERATE',
    resources: 'SUBSPACE PORTAL',
    services: [],
    primaryColor: '#3b82f6',
    secondaryColor: '#00d4ff',
    hasRings: true,
    discovered: false,
    description: 'Subspace anomaly leading to Citadel space. Element Zero and subspace fields interact.',
    scanDescription: 'Subspace-eezo interaction detected. Stable corridor to Citadel space. Proceed with caution.'
  }
];

export const warpGatePositions = {
  'gate-startrek-masseffect': { x: 38, y: 48, z: -4 }
};

const startrekGates = { warpGates, warpGatePositions };
export default startrekGates;
